module.exports = __webpack_public_path__ + "media/images/logo_dinersclub-06c70c88b418ae02e6ebdd909c909ab6.png";